import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=57583a02&scoped=true"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57583a02",
  null
  
)

export default component.exports